/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetDestinationDeliveriesParams = zod.object({
	limit: zod.number().optional(),
	offset: zod.number().optional()
});

export type GetDestinationDeliveriesParams = zod.input<typeof GetDestinationDeliveriesParams>;
export type GetDestinationDeliveriesParamsOutput = zod.output<
	typeof GetDestinationDeliveriesParams
>;
